module.exports = __webpack_public_path__ + "static/media/notificationIconHover.1849657e.svg";